/* @flow */
import * as React from 'react';
import idx from 'idx';
import qs from 'qs';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import Slider from 'react-slick';
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader.jsx';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import Glyph from 'components/Glyph.jsx';
import Heading from 'components/Heading.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import Row from 'components/Row.jsx';
import Text from 'components/Text.jsx';

import './styles/AdminUpgradeTour.scss';

const slides = [
  {
    key: 'rostering',
    image: require('assets/images/admin/AdminUpgradeTour/rostering.svg'),
    text:
      'Involve even the hardest-to-reach students and parents in school communication by connecting Remind to your school roster information.',
  },
  {
    key: 'analytics',
    image: require('assets/images/admin/AdminUpgradeTour/analytics.svg'),
    text: 'Manage your school and track progress with advanced controls and analytics',
  },
  {
    key: 'documentation',
    image: require('assets/images/admin/AdminUpgradeTour/documentation.svg'),
    text: 'Streamline documentation across all home-school communication',
  },
  {
    key: 'messaging',
    image: require('assets/images/admin/AdminUpgradeTour/messaging.svg'),
    text:
      'Make meaningful communication easier than ever for teachers with voice calls and longer messages',
  },
];

type Props = {
  params: { orgUuid?: string },
  quoteRequestedByUser?: boolean,
  onClick: Function,
};

class AdminUpgradeTour extends React.Component<Props> {
  renderSlide(slide: { key: string, image: string, text: string }) {
    return (
      <div className="AdminUpgradeTour-slide" key={slide.key}>
        <Container size="large">
          <div className="AdminUpgradeTour-slide-text">
            <Heading level="1" levelStyle="2" align="center">
              {slide.text}
            </Heading>
          </div>
          <Image src={slide.image} full />
        </Container>
      </div>
    );
  }

  renderBanner() {
    const utmParams = qs.stringify({
      utm_source: LinkConstants.UTM_SOURCE_ADMIN,
      utm_medium: LinkConstants.UTM_MEDIUM_PRODUCT,
      utm_campaign: LinkConstants.UTM_CAMPAIGN_UNPAID_ORG,
    });
    return (
      <div className="AdminUpgradeTour-banner">
        <Row size="small">
          <Heading level="2" levelStyle="4">
            Meaningful communication for every teacher, student, and parent in your school or
            district
          </Heading>
        </Row>
        {this.props.quoteRequestedByUser ? (
          <Text color="thunder">
            We received your invoice request and will be in touch shortly.
          </Text>
        ) : (
          <Button
            to={
              this.props.params.orgUuid
                ? `/admin_upgrade/${this.props.params.orgUuid}?${utmParams}`
                : `/admin_upgrade?${utmParams}`
            }
            eventKey="admin_first_onboarding.admin_tour.afo_banner.buy_now.click"
            data-test="self-serve-button">
            Buy Now
          </Button>
        )}
      </div>
    );
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      nextArrow: (
        <Link onClick={this.props.onClick} aria-label="Go forward">
          <Glyph
            color="brand"
            size="xxlarge"
            name="chevron-right"
            className="AdminUpgradeTour-nextArrow"
          />
        </Link>
      ),
      prevArrow: (
        <Link onClick={this.props.onClick} aria-label="Go back">
          <Glyph
            color="brand"
            size="xxlarge"
            name="chevron-left"
            className="AdminUpgradeTour-prevArrow"
          />
        </Link>
      ),
    };
    return (
      <div className="AdminUpgradeTour">
        <AdminUpgradePageHeader
          title="Remind School & District Plans"
          screen="admin_first_onboarding.admin_tour"
        />
        <div className="AdminUpgradeTour-slider">
          <Container size="large" className="AdminUpgradeTour-sliderContainer">
            <Slider {...settings}>{slides.map(this.renderSlide)}</Slider>
          </Container>
        </div>
        {this.renderBanner()};
      </div>
    );
  }
}

const withOrganization = graphql(
  gql`
    query AdminUpgradeTour($organizationUuid: String!) {
      organizations(uuids: [$organizationUuid]) {
        uuid
        quoteRequestedByUser {
          uuid
        }
      }
    }
  `,
  {
    options: ({ params }) => ({
      variables: {
        organizationUuid: params.orgUuid,
      },
    }),
    props: ({ data }) => ({
      quoteRequestedByUser: !!idx(data, _ => _.organizations[0].quoteRequestedByUser),
    }),
    skip: ({ params }) => !params.orgUuid,
  }
);

export { AdminUpgradeTour };
export default withOrganization(AdminUpgradeTour);
